import React from 'react';
function Heading3({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M3 4v16M3.5 12h8M12 4v16M16.5 14c.5-1.5 1.5-1.5 2-1.5 1.5 0 2.5 2 0 3.5M16.5 18.5C17 20 18 20 18.638 20c1.548 0 2.862-3-.138-4"
      />
    </svg>
  );
}

export default Heading3;
